import Vue from 'vue'
import Router from 'vue-router'
import homepage from '@/components/pages/homepage'
import store from '../store';

//Autentification
import login from '@/components/pages/authentication/login'
import forgot_password_page from '@/components/pages/authentication/forgot_password_page'
import confirm_email_page from '@/components/pages/authentication/confirm_email_page'

//Super Admin
import billings from '@/components/pages/superadmin/billings'
import disciplines from '@/components/pages/superadmin/disciplines'

//Users
import profile from '@/components/pages/users/profile/profile'
import companies from '@/components/pages/companies/companies'
import company_certificates from '@/components/pages/companies/company_certificates'
import roles from '@/components/pages/users/roles'
import roles_permissions from '@/components/pages/users/roles_permissions'
import user_roles from '@/components/pages/users/user_roles'
import users from '@/components/pages/users/users'
import welders from '@/components/pages/users/welders'

//Projects
import projects from '@/components/pages/project/projects/projects'
import milestones from '@/components/pages/project/projects/milestones'

//Project Settings
import project_settings from '@/components/pages/project/project_settings/project_settings'

//Progress Settings
import progress_settings from '@/components/pages/project/progress_settings/progress_settings'
import progress_settings_steps_piping from '@/components/pages/project/progress_settings/progress_settings_steps/progress_settings_steps_piping'
import progress_settings_steps_equipment from '@/components/pages/project/progress_settings/progress_settings_steps/progress_settings_steps_equipment'
import progress_settings_steps_ei from '@/components/pages/project/progress_settings/progress_settings_steps/progress_settings_steps_ei'
import progress_settings_steps_steelstructure from '@/components/pages/project/progress_settings/progress_settings_steps/progress_settings_steps_steelstructure'
import progress_settings_steps_civil from '@/components/pages/project/progress_settings/progress_settings_steps/progress_settings_steps_civil'
import progress_settings_steps_painting from '@/components/pages/project/progress_settings/progress_settings_steps/progress_settings_steps_painting'
import progress_settings_steps_insulation from '@/components/pages/project/progress_settings/progress_settings_steps/progress_settings_steps_insulation'

//Project Empty
import project_empty from '@/components/pages/project/projects/project_empty/'

//Progress Reporting
import project_progress_reporting from '@/components/pages/project/project_progress_reporting/project_progress_reporting'

//% Progress
import piping_value from '@/components/pages/project/percent_progress/piping_value/piping_value.vue'
import piping_weight from '@/components/pages/project/percent_progress/piping_weight/piping_weight.vue'
import progress_welding from '@/components/pages/project/percent_progress/welding/progress_welding.vue'
import progress_bw_welding from '@/components/pages/project/percent_progress/bw_welding/progress_bw_welding.vue'

import other_discipline_equipment from '@/components/pages/project/percent_progress/other_discipline/equipment/other_discipline_equipment.vue'
import other_discipline_ei from '@/components/pages/project/percent_progress/other_discipline/ei/other_discipline_ei.vue'
import other_discipline_steelstructure from '@/components/pages/project/percent_progress/other_discipline/steelstructure/other_discipline_steelstructure.vue'
import other_discipline_civil from '@/components/pages/project/percent_progress/other_discipline/civil/other_discipline_civil.vue'
import other_discipline_painting from '@/components/pages/project/percent_progress/other_discipline/painting/other_discipline_painting.vue'
import other_discipline_insulation from '@/components/pages/project/percent_progress/other_discipline/insulation/other_discipline_insulation.vue'

import progress_calculation_piping from '@/components/pages/project/percent_progress/calculation/piping_calculation.vue'
import progress_calculation_steel from '@/components/pages/project/percent_progress/calculation/steel_calculation.vue'
import progress_calculation_equipment from '@/components/pages/project/percent_progress/calculation/equipment_calculation.vue'
import progress_calculation_civil from '@/components/pages/project/percent_progress/calculation/civil_calculation.vue'
import progress_calculation_ei from '@/components/pages/project/percent_progress/calculation/ei_calculation.vue'
import progress_calculation_other from '@/components/pages/project/percent_progress/calculation/other_calculation.vue'

//Teams
import teams from '@/components/pages/project/teams/teams'
import team_members from '@/components/pages/project/teams/team_members'

//Disciplines
import disciplines_project from '@/components/pages/project/project_disciplines/project_disciplines'

//Line List
import line_list from '@/components/pages/project/line_list/line_list'
import line_list_revisioncontrol from '@/components/pages/project/line_list/line_list_revisioncontrol'

//Isometric Management
import isometric_management from '@/components/pages/project/isometric_management/isometric_management'
import isometric_management_revisioncontrol from '@/components/pages/project/isometric_management/isometric_management_revisioncontrol'
import isometric_management_parts from '@/components/pages/project/isometric_management/isometric_management_parts'
import isometric_material_request from '@/components/pages/project/isometric_management/isometric_material_request'
import isometric_management_best_prefabrication from '@/components/pages/project/isometric_management/calculation/isometric_management_best_prefabrication'
import isometric_management_best_erection from '@/components/pages/project/isometric_management/calculation/isometric_management_best_erection'

//Pressure Test Planning
import pressure_test_planning from '@/components/pages/project/pressure_test_planning/pressure_test_planning'
import pressure_test_planning_revisioncontrol from '@/components/pages/project/pressure_test_planning/pressure_test_planning_revisioncontrol'

//Blinds & Removed Items
import blinds_and_removed_items from '@/components/pages/project/blinds_and_removed_items/blinds_and_removed_items'

//Welding
import weld from '@/components/pages/project/welding/welds/weld'
import weld_iso from '@/components/pages/project/welding/welds/weld_iso'
import weld_revisioncontrol from '@/components/pages/project/welding/welds/weld_revisioncontrol'
import current_welds from '@/components/pages/project/welding/current_welds/current_welds'
import ndt_welds from '@/components/pages/project/welding/ndt_welds/ndt_welds'
import documentation from '@/components/pages/project/welding/welding_documentation/documentation'
import filler_material from '@/components/pages/project/welding/filler_material/filler_material'

//Tie In Management
import tie_in_management from '@/components/pages/project/tie_in_management/tie_in_management'
import tie_in_management_revisioncontrol from '@/components/pages/project/tie_in_management/tie_in_management_revisioncontrol'

//Subcontractors
import subcontractors from '@/components/pages/project/subcontractors/subcontractors'
import subcontractors_price_list from '@/components/pages/project/subcontractors/price_list/subcontractors_price_list'

//Scaffolding
import scaffolding from '@/components/pages/project/construction/scaffolding/scaffolding'
import scaffolding_parts from '@/components/pages/project/construction/scaffolding/scaffolding_parts'

//Punch List
import punch_list from '@/components/pages/project/construction/punch_list/punch_list'

//Spool Management
import spool_management from '@/components/pages/project/construction/spool_management/spool_management'

//Site Instructions
import site_instructions from '@/components/pages/project/construction/site_instructions/site_instructions'

//Painting
import painting from '@/components/pages/project/construction/painting/painting'

//Material Management
import project_parts from '@/components/pages/project/construction/material_management/project_parts'
import isometric_material_requests from '@/components/pages/project/construction/material_management/isometric_material_requests/isometric_material_requests'
import change_order_material_requests from '@/components/pages/project/construction/material_management/change_order_material_requests/change_order_material_requests'

//Drawings
import steel_drawings from '@/components/pages/project/construction/drawings/steel_drawings/steel_drawings'
import steel_drawings_revisioncontrol from '@/components/pages/project/construction/drawings/steel_drawings/steel_drawings_revisioncontrol'
import steel_drawings_parts from '@/components/pages/project/construction/drawings/steel_drawings/steel_drawings_parts'

import equipment_drawings from '@/components/pages/project/construction/drawings/equipment_drawings/equipment_drawings'
import equipment_drawings_revisioncontrol from '@/components/pages/project/construction/drawings/equipment_drawings/equipment_drawings_revisioncontrol'
import equipment_items from '@/components/pages/project/construction/drawings/equipment_drawings/equipment_items'

import civil_drawings from '@/components/pages/project/construction/drawings/civil_drawings/civil_drawings'
import civil_drawings_revisioncontrol from '@/components/pages/project/construction/drawings/civil_drawings/civil_drawings_revisioncontrol'
import civil_drawings_parts from '@/components/pages/project/construction/drawings/civil_drawings/civil_drawings_parts'

import ei_drawings from '@/components/pages/project/construction/drawings/ei_drawings/ei_drawings'
import ei_drawings_revisioncontrol from '@/components/pages/project/construction/drawings/ei_drawings/ei_drawings_revisioncontrol'
import ei_drawings_parts from '@/components/pages/project/construction/drawings/ei_drawings/ei_drawings_parts'

import other_drawings from '@/components/pages/project/construction/drawings/other_drawings/other_drawings'
import other_drawings_revisioncontrol from '@/components/pages/project/construction/drawings/other_drawings/other_drawings_revisioncontrol'
import other_drawings_parts from '@/components/pages/project/construction/drawings/other_drawings/other_drawings_parts'

//Calculation
import overview_piping from '@/components/pages/project/commercial/calculation/overview_piping'
import overview_equipment from '@/components/pages/project/commercial/calculation/overview_equipment'
import overview_painting from '@/components/pages/project/commercial/calculation/overview_painting'
import overview_scaffolding from '@/components/pages/project/commercial/calculation/overview_scaffolding'
import overview_insulation from '@/components/pages/project/commercial/calculation/overview_insulation'
import overview_steel from '@/components/pages/project/commercial/calculation/overview_steel'
import overview_civil from '@/components/pages/project/commercial/calculation/overview_civil'
import overview_ei from '@/components/pages/project/commercial/calculation/overview_ei'
import overview_other from '@/components/pages/project/commercial/calculation/overview_other'
import overview_tie_in from '@/components/pages/project/commercial/calculation/overview_tie_in'
import overview_change_order from '@/components/pages/project/commercial/calculation/overview_change_order'

//Change Orders
import change_orders from '@/components/pages/project/commercial/change_orders/change_orders'
import change_orders_revisioncontrol from '@/components/pages/project/commercial/change_orders/change_orders_revisioncontrol'
import change_orders_parts from '@/components/pages/project/commercial/change_orders/change_orders_parts'

//Daily Logs
import daily_logs from '@/components/pages/project/administrative/daily_logs/daily_logs'
import daily_logs_users from '@/components/pages/project/administrative/daily_logs/daily_logs_users'

//Hours Recording
import hours_recording from '@/components/pages/project/administrative/hours_recording/hours_recording'

//Delays
import delays from '@/components/pages/project/administrative/delays/delays'

//Messages
import submittal from '@/components/pages/project/administrative/ticket/submittal/submittal.vue'
import tq from '@/components/pages/project/administrative/ticket/tq/tq.vue'

//Task Manager
import task_manager from '@/components/pages/project/administrative/task_manager/task_manager.vue'

//General Documents
import general_documents from '@/components/pages/project/administrative/general_documents/general_documents'

//Storage
import storage from '@/components/pages/project/administrative/storage/storage'

//Calibrated Items
import calibrated_items from '@/components/pages/project/calibrated_items/calibrated_items'

import qs from 'qs';

Vue.use(Router);

const checkUserLoaded = (to, from, next) => {
  function proceed () {
    if (store.state.user.user) {
        if (!hasPermission(to.meta.requiresPermissions)) {//check for permissions if user loaded
            next({
                path: '/'
            })
        } else {
            next()
        }
    }
  }
  if (!store.state.user.user) {
    store.state.preloader = true;
    store.watch(
      (state) => state.user.user,
      (value) => {
        if (value.id) {
          proceed()
        }
      }
    )
  } else {
    proceed()
  }
}

const hasPermission = (permissions) => {
    if (permissions.length == 0) return true;//this requires at least to be logged in

    let user_permissions = [];
    if (store.state.userSelectedRole) {
        if (store.state.userSelectedRole.permissions) {
            for (var key in store.state.userSelectedRole.permissions) {
                user_permissions.push(key);
            }
        }
    }

    return permissions.some(permission => user_permissions.indexOf(permission) !== -1);
}

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/superadmin/billings',
            name: 'billings',
            component: billings,
            meta: {
                title: "Billings",
                requiresPermissions: [
                                    'platform',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },

        {
            path: '/companies',
            name: 'companies',
            component: companies,
            meta: {
                title: "Companies",
                requiresPermissions: [
                                    'platform',
                                    'company',
                                    ]
            },
            beforeEnter: checkUserLoaded,
            props: (route) => ({ filters: route.query.filters })
        },
        {
            path: '/company/:id/certificates',
            name: 'company_certificates',
            component: company_certificates,
            meta: {
                title: "Company Certificates",
                requiresPermissions: [
                                    'platform',
                                    'company',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },

        {
            path: '/users/roles',
            name: 'roles',
            component: roles,
            meta: {
                title: "Roles",
                requiresPermissions: [
                                    'platform',
                                    'roles',
                                     ],
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/users/role/:id/permissions',
            name: 'roles_permissions',
            component: roles_permissions,
            meta: {
                title: "Roles Permissions",
                requiresPermissions: [
                                    'platform',
                                    'roles',
                                     ],
            },
            beforeEnter: checkUserLoaded
        },

        {
            path: '/users',
            name: 'users',
            component: users,
            meta: {
                title: "Users",
                requiresPermissions: [
                                    'platform',
                                    'users',
                                     ]
            },
            beforeEnter: checkUserLoaded
        },

        {
            path: '/user/:id/roles',
            name: 'user_roles',
            component: user_roles,
            meta: {
                title: "User roles",
                requiresPermissions: [
                                    'platform',
                                    'users',
                                     ]
            },
            beforeEnter: checkUserLoaded
        },

        {
            path: '/users/welders',
            name: 'welders',
            component: welders,
            meta: {
                title: "Welders",
                requiresPermissions: [
                                    'welders',
                                     ]
            },
            beforeEnter: checkUserLoaded
        },

        {
            path: '/disciplines',
            name: 'disciplines',
            component: disciplines,
            meta: {
                title: "Disciplines",
                requiresPermissions: [
                                    'platform',
                                     ]
            },
            beforeEnter: checkUserLoaded
        },

        {
            path: '/projects',
            name: 'projects',
            component: projects,
            meta: {
                title: "Projects",
                requiresPermissions: [
                                    'project',
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/disciplines',
            name: 'disciplines_project',
            component: disciplines_project,
            meta: {
                title: "Disciplines",
                requiresPermissions: [
                                     'project_disciplines'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/drawings/steel_drawings',
            name: 'steel_drawings',
            component: steel_drawings,
            meta: {
                title: "Steel Drawings",
                requiresPermissions: [
                                    'project_drawing_steel',
                                    'project_drawing_steel_part_list'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/drawings/steel_drawings/:id2/parts',
            name: 'steel_drawings_parts',
            component: steel_drawings_parts,
            meta: {
                title: "Steel Drawing - Parts",
                requiresPermissions: [
                                    'project_drawing_steel',
                                    'project_drawing_steel_part_list'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/drawings/steel_drawings/:id2/revision',
            name: 'steel_drawings_revisioncontrol',
            component: steel_drawings_revisioncontrol,
            meta: {
                title: "Steel Drawings - Revision Control",
                requiresPermissions: [
                    'project_drawing_steel',
                    'project_revisions',
                ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/drawings/equipment_drawings',
            name: 'equipment_drawings',
            component: equipment_drawings,
            meta: {
                title: "Equipment Drawings",
                requiresPermissions: [
                                    'project_drawing_equipment'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/drawings/equipment_drawings/:id2/revision',
            name: 'equipment_drawings_revisioncontrol',
            component: equipment_drawings_revisioncontrol,
            meta: {
                title: "Equipment Drawings - Revision Control",
                requiresPermissions: [
                                    'project_drawing_equipment',
                                    'project_revisions',
                ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/drawings/equipment_drawings/:id2/items',
            name: 'equipment_items',
            component: equipment_items,
            meta: {
                title: "Equipment Drawing - Items",
                requiresPermissions: [
                                    'project_drawing_equipment_item_list',
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/drawings/civil_drawings',
            name: 'civil_drawings',
            component: civil_drawings,
            meta: {
                title: "Civil Drawings",
                requiresPermissions: [
                                    'project_drawing_civil',
                                    'project_drawing_civil_part_list',
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/drawings/civil_drawings/:id2/revision',
            name: 'civil_drawings_revisioncontrol',
            component: civil_drawings_revisioncontrol,
            meta: {
                title: "Civil Drawings - Revision Control",
                requiresPermissions: [
                                    'project_drawing_civil',
                                    'project_revisions',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/drawings/civil_drawings/:id2/parts',
            name: 'civil_drawings_parts',
            component: civil_drawings_parts,
            meta: {
                title: "Civil Drawing - Parts",
                requiresPermissions: [
                                    'project_drawing_civil',
                                    'project_drawing_civil_part_list',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/drawings/ei_drawings',
            name: 'ei_drawings',
            component: ei_drawings,
            meta: {
                title: "E&I Drawings",
                requiresPermissions: [
                                    'project_drawing_ei'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/drawings/ei_drawings/:id2/revision',
            name: 'ei_drawings_revisioncontrol',
            component: ei_drawings_revisioncontrol,
            meta: {
                title: "E&I Drawings - Revision Control",
                requiresPermissions: [
                                        'project_drawing_ei',
                                        'project_revisions',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/drawings/ei_drawings/:id2/parts',
            name: 'ei_drawings_parts',
            component: ei_drawings_parts,
            meta: {
                title: "E&I Drawing - Parts",
                requiresPermissions: [
                                    'project_drawing_ei',
                                    'project_drawing_ei_part_list',
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/drawings/other_drawings',
            name: 'other_drawings',
            component: other_drawings,
            meta: {
                title: "Other Drawings",
                requiresPermissions: [
                                    'project_drawing_other'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/drawings/other_drawings/:id2/revision',
            name: 'other_drawings_revisioncontrol',
            component: other_drawings_revisioncontrol,
            meta: {
                title: "Other Drawings - Revision Control",
                requiresPermissions: [
                                    'project_drawing_other',
                                    'project_revisions',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/drawings/other_drawings/:id2/parts',
            name: 'other_drawings_parts',
            component: other_drawings_parts,
            meta: {
                title: "Other Drawing - Parts",
                requiresPermissions: [
                    'project_drawing_other',
                    'project_drawing_other_part_list',
                ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/commercial/change_orders',
            name: 'change_orders',
            component: change_orders,
            meta: {
                title: "Change Orders",
                requiresPermissions: [
                                    'project_change_orders'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/commercial/change_orders/:id2/parts',
            name: 'change_orders_parts',
            component: change_orders_parts,
            meta: {
                title: "Change Orders - Parts",
                requiresPermissions: [
                                    'project_change_orders',
                                    'project_change_orders_part_list'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/commercial/change_orders/:id2/revision',
            name: 'change_orders_revisioncontrol',
            component: change_orders_revisioncontrol,
            meta: {
                title: "Change Orders - Revision Control",
                requiresPermissions: [
                                    'project_change_orders',
                                    'project_revisions'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/material_management/project_parts',
            name: 'project_parts',
            component: project_parts,
            meta: {
                title: "Project Parts",
                requiresPermissions: [
                                    'project_stock',
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/material_management/isometric_material_requests',
            name: 'isometric_material_requests',
            component: isometric_material_requests,
            meta: {
                title: "Isometric Material Requests",
                requiresPermissions: [
                                    'project_isometric_material_requests'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/material_management/change_order_material_requests',
            name: 'change_order_material_requests',
            component: change_order_material_requests,
            meta: {
                title: "Change Order Material Requests",
                requiresPermissions: [
                                    'project_change_order_material_requests'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/line_list',
            name: 'line_list',
            component: line_list,
            meta: {
                title: "Line List",
                requiresPermissions: [
                                       'project_line'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/line_list/:id2/revision',
            name: 'line_list_revisioncontrol',
            component: line_list_revisioncontrol,
            meta: {
                title: "Line List - Revision Control",
                requiresPermissions: [
                                    'project_line',
                                    'project_revisions',
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/project_settings',
            name: 'project_settings',
            component: project_settings,
            meta: {
                title: "Project Settings",
                requiresPermissions: [
                                    'project_settings'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress_settings',
            name: 'progress_settings',
            component: progress_settings,
            meta: {
                title: "Progress Settings",
                requiresPermissions: [
                                    'project_progress_settings'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress_settings_steps_piping/:id2',
            name: 'progress_settings_steps_piping',
            component: progress_settings_steps_piping,
            meta: {
                title: "Progress Settings - Steps Piping",
                requiresPermissions: [
                                    'project_progress_settings_steps'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress_settings_steps_equipment/:id2',
            name: 'progress_settings_steps_equipment',
            component: progress_settings_steps_equipment,
            meta: {
                title: "Progress Settings - Steps Equipment",
                requiresPermissions: [
                                    'project_progress_settings_steps'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress_settings_steps_ei/:id2',
            name: 'progress_settings_steps_ei',
            component: progress_settings_steps_ei,
            meta: {
                title: "Progress Settings - Steps E&I",
                requiresPermissions: [
                                    'project_progress_settings_steps'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress_settings_steps_steelstructure/:id2',
            name: 'progress_settings_steps_steelstructure',
            component: progress_settings_steps_steelstructure,
            meta: {
                title: "Progress Settings - Steps Steel Structure",
                requiresPermissions: [
                                    'project_progress_settings_steps'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress_settings_steps_civil/:id2',
            name: 'progress_settings_steps_civil',
            component: progress_settings_steps_civil,
            meta: {
                title: "Progress Settings - Steps Steel Civil",
                requiresPermissions: [
                                    'project_progress_settings_steps'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress_settings_steps_painting/:id2',
            name: 'progress_settings_steps_painting',
            component: progress_settings_steps_painting,
            meta: {
                title: "Progress Settings - Steps Steel Painting",
                requiresPermissions: [
                                    'project_progress_settings_steps'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress_settings_steps_insulation/:id2',
            name: 'progress_settings_steps_insulation',
            component: progress_settings_steps_insulation,
            meta: {
                title: "Progress Settings - Steps Steel Insulation",
                requiresPermissions: [
                                    'project_progress_settings_steps'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/piping_value',
            name: 'piping_value',
            component: piping_value,
            meta: {
                title: "Progress - Piping Value",
                requiresPermissions: [
                                        'project_progress_piping_value',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/piping_weight',
            name: 'piping_weight',
            component: piping_weight,
            meta: {
                title: "Progress - Piping Weight",
                requiresPermissions: [
                                        'project_progress_piping_weight',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/welding',
            name: 'progress_welding',
            component: progress_welding,
            meta: {
                title: "Progress Welding",
                requiresPermissions: [
                                        'project_progress_welding',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/bw_welding',
            name: 'progress_bw_welding',
            component: progress_bw_welding,
            meta: {
                title: "Progress BW Welding",
                requiresPermissions: [
                                        'project_progress_bw_welding',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/other_discipline/equipment',
            name: 'other_discipline_equipment',
            component: other_discipline_equipment,
            meta: {
                title: "Progress Other Discipline - Equipment",
                requiresPermissions: [
                                        'project_progress_other_discipline_equipment',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/other_discipline/ei',
            name: 'other_discipline_ei',
            component: other_discipline_ei,
            meta: {
                title: "Progress Other Discipline - E&I",
                requiresPermissions: [
                                        'project_progress_other_discipline_ei',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/other_discipline/steelstructure',
            name: 'other_discipline_steelstructure',
            component: other_discipline_steelstructure,
            meta: {
                title: "Progress Other Discipline - Steel Structure",
                requiresPermissions: [
                                        'project_progress_other_discipline_steelstructure',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/other_discipline/civil',
            name: 'other_discipline_civil',
            component: other_discipline_civil,
            meta: {
                title: "Progress Other Discipline - Civil",
                requiresPermissions: [
                                        'project_progress_other_discipline_civil',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/other_discipline/painting',
            name: 'other_discipline_painting',
            component: other_discipline_painting,
            meta: {
                title: "Progress Other Discipline - Painting",
                requiresPermissions: [
                                        'project_progress_other_discipline_painting',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/other_discipline/insulation',
            name: 'other_discipline_insulation',
            component: other_discipline_insulation,
            meta: {
                title: "Progress Other Discipline - Insulation",
                requiresPermissions: [
                                        'project_progress_other_discipline_insulation',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/calculation/piping',
            name: 'progress_calculation_piping',
            component: progress_calculation_piping,
            meta: {
                title: "Progress Calculation Piping",
                requiresPermissions: [
                                    'project_progress_calculation_piping'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/calculation/steel',
            name: 'progress_calculation_steel',
            component: progress_calculation_steel,
            meta: {
                title: "Progress Calculation Steel",
                requiresPermissions: [
                                    'project_progress_calculation_steel'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/calculation/equipment',
            name: 'progress_calculation_equipment',
            component: progress_calculation_equipment,
            meta: {
                title: "Progress Calculation Equipment",
                requiresPermissions: [
                                    'project_progress_calculation_equipment'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/calculation/civil',
            name: 'progress_calculation_civil',
            component: progress_calculation_civil,
            meta: {
                title: "Progress Calculation Civil",
                requiresPermissions: [
                                    'project_progress_calculation_civil'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/calculation/ei',
            name: 'progress_calculation_ei',
            component: progress_calculation_ei,
            meta: {
                title: "Progress Calculation E&I",
                requiresPermissions: [
                                    'project_progress_calculation_ei'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/progress/calculation/other',
            name: 'progress_calculation_other',
            component: progress_calculation_other,
            meta: {
                title: "Progress Calculation Other",
                requiresPermissions: [
                                    'project_progress_calculation_other'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/isometric_management',
            name: 'isometric_management',
            component: isometric_management,
            meta: {
                title: "Isometric Management",
                requiresPermissions: [
                                    'project_isometric'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/isometric_management/:id2/revision',
            name: 'isometric_management_revisioncontrol',
            component: isometric_management_revisioncontrol,
            meta: {
                title: "Isometric Management - Revision Control",
                requiresPermissions: [
                    'project_isometric',
                    'project_revisions',
                ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/isometric_management/:id2/requests',
            name: 'isometric_material_request',
            component: isometric_material_request,
            meta: {
                title: "Material Requests",
                requiresPermissions: [
                    'project_isometric',
                    'project_isometric_part_request',
                ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/isometric_management/:id2/parts',
            name: 'isometric_management_parts',
            component: isometric_management_parts,
            meta: {
                title: "Isometric Management - Parts",
                requiresPermissions: [
                    'project_isometric',
                    'project_isometric_part_list',
                ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/isometric_management_best_prefabrication',
            name: 'isometric_management_best_prefabrication',
            component: isometric_management_best_prefabrication,
            meta: {
                title: "Isometric Management - Best Prefabrication",
                requiresPermissions: [
                                    'project_isometric'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/isometric_management_best_erection',
            name: 'isometric_management_best_erection',
            component: isometric_management_best_erection,
            meta: {
                title: "Isometric Management - Best Erection",
                requiresPermissions: [
                                    'project_isometric'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/pressure_test_planning',
            name: 'pressure_test_planning',
            component: pressure_test_planning,
            meta: {
                title: "Pressure Test Planning",
                requiresPermissions: [
                                    'project_pressure_test_planning'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/pressure_test_planning/:id2/revision',
            name: 'pressure_test_planning_revisioncontrol',
            component: pressure_test_planning_revisioncontrol,
            meta: {
                title: "Pressure Test Planning - Revision Control",
                requiresPermissions: [
                                        'project_pressure_test_planning',
                                        'project_revisions'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/blinds_and_removed_items',
            name: 'blinds_and_removed_items',
            component: blinds_and_removed_items,
            meta: {
                title: "Blinds & Removed Items",
                requiresPermissions: [
                                        'project_blind',
                                        'project_removed_item'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/welding/iso',
            name: 'weld_iso',
            component: weld_iso,
            meta: {
                title: "Welding",
                requiresPermissions: [
                                        'project_weld'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/welding/iso/:id2/weld',
            name: 'weld',
            component: weld,
            meta: {
                title: "Weld",
                requiresPermissions: [
                                    'project_weld'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/welding/weld/:id2/revision',
            name: 'weld_revisioncontrol',
            component: weld_revisioncontrol,
            meta: {
                title: "Weld - Revision Control",
                requiresPermissions: [
                                    'project_weld',
                                    'project_revisions'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/welding/current_welds',
            name: 'current_welds',
            component: current_welds,
            meta: {
                title: "Current Welds",
                requiresPermissions: [
                                    'project_current_welds'
                                    ]
            },
        },
        {
            path: '/project/:id/welding/ndt_welds',
            name: 'ndt_welds',
            component: ndt_welds,
            meta: {
                title: "NDT Welds",
                requiresPermissions: [
                                    'project_ndt_welds'
                                    ]
            },
        },
        {
            path: '/project/:id/welding/documentation',
            name: 'welding_documentation',
            component: documentation,
            meta: {
                title: "Welding Documentation",
                requiresPermissions: [
                                    'project_weld_documentation'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/welding/filler_material',
            name: 'filler_material',
            component: filler_material,
            meta: {
                title: "Filler Material",
                requiresPermissions: [
                                    'project_filler_material'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/punch_list',
            name: 'punch_list',
            component: punch_list,
            meta: {
                title: "Punch List",
                requiresPermissions: [
                                    'project_punch_list'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id',
            name: 'project_empty',
            component: project_empty,
            meta: {
                title: "Project",
                requiresPermissions: [
                                    'project',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/project_progress_reporting',
            name: 'project_progress_reporting',
            component: project_progress_reporting,
            meta: {
                title: "Project Progress Reporting: ",
                requiresPermissions: [
                                    'project_progress_reporting',
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/milestones',
            name: 'milestones',
            component: milestones,
            meta: {
                title: "Milestones",
                requiresPermissions: [
                                    'project_milestones'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },

        {
            path: '/project/:id/administrative/delays',
            name: 'delays',
            component: delays,
            meta: {
                title: "Delays",
                requiresPermissions: [
                                    'project_delays'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/administrative/messages/submittal',
            name: 'submittal',
            component: submittal,
            meta: {
                title: "Submittal",
                requiresPermissions: [
                                    'project_messages'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/administrative/messages/tq',
            name: 'tq',
            component: tq,
            meta: {
                title: "TQ",
                requiresPermissions: [
                                    'project_messages'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/administrative/task_manager',
            name: 'task_manager',
            component: task_manager,
            meta: {
                title: "Task Manager",
                requiresPermissions: [
                                    'project_task_manager'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/administrative/daily_logs',
            name: 'daily_logs',
            component: daily_logs,
            meta: {
                title: "Daily Logs",
                requiresPermissions: [
                                    'project_daily_log'
                                     ]
            },
            beforeEnter: checkUserLoaded

        },
        {
            path: '/project/:id/administrative/daily_logs/:idm/users',
            name: 'daily_logs_users',
            component: daily_logs_users,
            meta: {
                title: "Daily Log - Users",
                requiresPermissions: [
                                    'project_daily_log'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/spool_management',
            name: 'spool_management',
            component: spool_management,
            meta: {
                title: "Spool Management",
                requiresPermissions: [
                                    'project_spool_management'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/site_instructions',
            name: 'site_instructions',
            component: site_instructions,
            meta: {
                title: "Site Instructions",
                requiresPermissions: [
                                    'project_site_instructions'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/painting',
            name: 'painting',
            component: painting,
            meta: {
                title: "Painting",
                requiresPermissions: [
                                    'project_painting'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/tie_in_management',
            name: 'tie_in_management',
            component: tie_in_management,
            meta: {
                title: "Tie In Management",
                requiresPermissions: [
                                    'project_tie_in'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/tie_in_management/:id2/revision',
            name: 'tie_in_management_revisioncontrol',
            component: tie_in_management_revisioncontrol,
            meta: {
                title: "Tie In Management - Revision Control",
                requiresPermissions: [
                                        'project_tie_in',
                                        'project_revisions',
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/teams/',
            name: 'teams',
            component: teams,
            meta: {
                title: "Teams",
                requiresPermissions: [
                                    'project_teams'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/teams/:idm/members',
            name: 'team_members',
            component: team_members,
            meta: {
                title: "Team Members",
                requiresPermissions: [
                                    'project_teams'
                                     ],
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/subcontractors',
            name: 'subcontractors',
            component: subcontractors,
            meta: {
                title: "Subcontractors",
                requiresPermissions: [
                                     'project_subcontractors',
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/subcontractors/:id2/price_list',
            name: 'subcontractors_price_list',
            component: subcontractors_price_list,
            meta: {
                title: "Subcontractor Price List",
                requiresPermissions: [
                                     'project_subcontractors',
                                     'project_company_price_list'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/scaffolding',
            name: 'scaffolding',
            component: scaffolding,
            meta: {
                title: "Scaffolding",
                requiresPermissions: [
                                    'project_scaffolding'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/construction/scaffolding/:id2/parts',
            name: 'scaffolding_parts',
            component: scaffolding_parts,
            meta: {
                title: "Scaffolding Parts",
                requiresPermissions: [
                                    'project_scaffolding',
                                    'project_scaffolding_part_list'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/administrative/general_documents',
            name: 'general_documents',
            component: general_documents,
            meta: {
                title: "General Documents",
                requiresPermissions: [
                                    'project_general_documents'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },

        {
            path: '/project/:id/administrative/storage',
            name: 'storage',
            component: storage,
            meta: {
                title: "Storage",
                requiresPermissions: [
                                    'project_storage'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/administrative/hours_recording',
            name: 'hours_recording',
            component: hours_recording,
            meta: {
                title: "Hours Recording",
                requiresPermissions: [
                                    'project_hours_recording'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },

        {
            path: '/project/:id/calibrated_items',
            name: 'calibrated_items',
            component: calibrated_items,
            meta: {
                title: "Calibrated Items",
                requiresPermissions: [
                                    'project_calibrated_item'
                                     ]
            },
            beforeEnter: checkUserLoaded
        },

        {
            path: '/project/:id/calculation/overview_piping',
            name: 'overview_piping',
            component: overview_piping,
            meta: {
                title: "Overview Piping",
                requiresPermissions: [
                                    'project_calculation_overview_piping'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/calculation/overview_equipment',
            name: 'overview_equipment',
            component: overview_equipment,
            meta: {
                title: "Overview Equipment",
                requiresPermissions: [
                                    'project_calculation_overview_equipment'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/calculation/overview_painting',
            name: 'overview_painting',
            component: overview_painting,
            meta: {
                title: "Overview Painting",
                requiresPermissions: [
                                    'project_calculation_overview_painting'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/calculation/overview_scaffolding',
            name: 'overview_scaffolding',
            component: overview_scaffolding,
            meta: {
                title: "Overview Scaffolding",
                requiresPermissions: [
                                    'project_calculation_overview_scaffolding'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/calculation/overview_insulation',
            name: 'overview_insulation',
            component: overview_insulation,
            meta: {
                title: "Overview Insulation",
                requiresPermissions: [
                                    'project_calculation_overview_insulation'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/calculation/overview_steel_structure',
            name: 'overview_steel',
            component: overview_steel,
            meta: {
                title: "Overview Steel Structure",
                requiresPermissions: [
                                    'project_calculation_overview_steel'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/calculation/overview_civil_works',
            name: 'overview_civil',
            component: overview_civil,
            meta: {
                title: "Overview Civil Works",
                requiresPermissions: [
                                    'project_calculation_overview_civil'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/calculation/overview_ei_works',
            name: 'overview_ei',
            component: overview_ei,
            meta: {
                title: "Overview E&I",
                requiresPermissions: [
                                    'project_calculation_overview_ei'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/calculation/overview_other_works',
            name: 'overview_other',
            component: overview_other,
            meta: {
                title: "Overview Other Works",
                requiresPermissions: [
                                    'project_calculation_overview_other'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/calculation/overview_tie_in',
            name: 'overview_tie_in',
            component: overview_tie_in,
            meta: {
                title: "Overview Tie In",
                requiresPermissions: [
                                    'project_calculation_overview_tie_in'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },
        {
            path: '/project/:id/calculation/overview_change_order',
            name: 'overview_change_order',
            component: overview_change_order,
            meta: {
                title: "Overview Change Order",
                requiresPermissions: [
                                    'project_calculation_overview_change_order'
                                    ]
            },
            beforeEnter: checkUserLoaded
        },

        /* profile */
        {
            path: '/profile',
            component: profile,
            meta: {
                title: "User Profile",
                requiresPermissions: [
                                     ]
            },
            beforeEnter: checkUserLoaded
        },

        /* homepage */
        {
            path: '/',
            name: 'homepage',
            component: homepage,
            meta: {
                title: "Home Page",
                requiresPermissions: [],
            },
            beforeEnter: checkUserLoaded
        },

        /* no authentication required */
        {
            path: '/login',
            name: 'Login Page',
            component: login,
            meta: {
                title: "Login",
            },
        },
        {
            path: '/forgotpassword',
            name: 'forgot_password_page',
            component: forgot_password_page,
            meta: {
                title: "Forgot Password",
            },
        },
        {
            path: '/confirmemail/:id/:token',
            name: 'confirm_email_page',
            component: confirm_email_page,
            meta: {
                title: "Confirm email",
            },
        },
        {
            path :'*',
            redirect: '/',
        },
    ],
    // set custom query resolver
    parseQuery(query) {
        return qs.parse(query);
    },
    stringifyQuery(query) {
        var result = qs.stringify(query, { encode: false });

        return result ? ('?' + result) : '';
    }
})

/*
router.beforeResolve((to, from, next) => {
  if (to.name) {
      NProgress.start()
  }
  next()
})
*/

router.beforeEach((to, from, next) => {
    /*
    if requiresPermissions = [] => only if logged in
    if requiresPermissions = ['some value', 'other value'] => only if logged in and has those permissions
    if no requiresPermissions => always
    */

    if (to.matched.some(record => record.meta.requiresPermissions)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        const rememberToken = localStorage.getItem('rememberToken');
        const jwt = sessionStorage.getItem('jwt');
        if (rememberToken && !store.state.user.user) {//has remember token, try to login
            store.state.preloader = true;
            let credentials = {
                rememberToken
            };
            store.dispatch('loginUser', credentials);
        } else if (!store.state.user.user && jwt) {//has auth, but user info is missing
            store.state.preloader = true;

            var us = {
                id: store.state.user.user.id
            };
            store.dispatch('getUser', us);
        } else if (!jwt) {//is not logged in
            return next({
                path: '/login',
            })
        } else if (jwt && store.state.user.user) {//is logged in and user info present
        }

        next() // make sure to always call next()!
    } else {
        next();
    }
})

router.afterEach((to, from) => {
    if (to.meta.title) {
        document.title = to.meta.title + " - " + store.site_name
        // set pageTitle to null if it is set manually elsewhere
        store.commit('changePageTitle', to.meta.title)
        store.commit("routeChange", "end")
        //NProgress.done();
        if (window.innerWidth <= 992) {
            store.commit('left_menu', "close")
        } else {
            store.commit('left_menu', "open")
        }
    }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js